import { render, staticRenderFns } from "./UsersettingComponent.vue?vue&type=template&id=1951d07e&"
import script from "./UsersettingComponent.vue?vue&type=script&lang=js&"
export * from "./UsersettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersettingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports